import { render, staticRenderFns } from "./WPBaseDatepicker.vue?vue&type=template&id=10c6d532"
import script from "./WPBaseDatepicker.vue?vue&type=script&lang=ts"
export * from "./WPBaseDatepicker.vue?vue&type=script&lang=ts"
import style0 from "./WPBaseDatepicker.vue?vue&type=style&index=0&id=10c6d532&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports